export class VisaOshc {
    IsOnshoreWhileLodgingVisa: boolean;
    HoldsAustralianVisa: boolean;

    // we need to use VisaSubclassId
    VisaSubclassId: number | null;
    VisaSubclassCode: string;    
    VisaSubclassDescription: string;
    VisaExpiryDate: string;
    VisaNumber: string;

    HasOshc: boolean;
    OshcProviderCode: string;
    OshcProviderName: string;
    OshcExpiryDate: string;
    IsVisaStatusChanged: boolean;
    IsHealthCoverFromDEInternational: boolean;
    IsReciprocalHealthCareCountry: boolean;
}
